<template>
  <div :class="['field-component', field.type]">
    <label :style='labelStyle' v-if='label !== ""'>{{label}}<span v-if='isRequiredField' class='required'>*</span></label>
    <p class='help-text' v-if='field.helpText' v-html='field.helpText'></p>
    <input @keyup='onKeyUp($event)' v-if='field.type == "text"' :autocomplete='field.autocomplete' :name='name' :placeholder='field.placeholder' type="text" @input='updateOptionDebounced(name, $event)' v-model='localValue' class='field-text' ref='input'/>

    <input @keyup='onKeyUp($event)' v-if='field.type == "number"' :autocomplete='field.autocomplete' :name='name' :placeholder='field.placeholder' type="number" @input='updateOptionDebounced(name, $event)' v-model='localValue' class='field-text' ref='input'/>

    <input @keyup='onKeyUp($event)' v-if='field.type == "range"' :autocomplete='field.autocomplete' :name='name' :placeholder='field.placeholder' type="range" :min='field.min || 0' :max='field.max || 100' :step='field.step || 1' @input='updateOptionDebounced(name, $event)' v-model='localValue' class='field-text' ref='input'/>

    <textarea v-if='field.type == "textarea"' class='field-textarea' @keyup='updateOptionDebounced(name, $event)' v-model='localValue'></textarea>
    <div class='field-trix' v-if='field.type == "trix"'>
      <input type='hidden' :id='"trix-" + randomKey' @change='updateOptionDebounced(name, $event)' v-model='localValue'/>
      <trix-editor  :style='inputStyle' ref='trixfield' :placeholder='field.placeholder' @trix-change='trixUpdate' :input='"trix-" + randomKey'></trix-editor>
    </div>
    <div v-if='field.type == "media"'>
      <div v-if='localValue' class='file-image-wrapper'>
        <span v-show='imageExists'>
          <img class='file-image' @error='imageLoaded(false)' @load='imageLoaded(true)' :src='localValue'/>
          <a class='close' @click.prevent='clearMedia' v-if='localValue'><ion-icon name="close-circle"></ion-icon></a>
        </span>
      </div>
      <input v-model='localValue' :type='imageURLFieldType' @keyup='updateOptionImmediately(field.name, $event)' @change='updateOptionImmediately(field.name, $event)'>
      <a @click.prevent='openMedia' class='button'>{{field.buttonText || 'Library&hellip;'}}</a>
      <a @click.prevent='toggleImageURL' class='button'>URL</a>
    </div>

    <div v-if='field.type =="color"' class='field-preview--color'>
      <ion-icon class='remove-color' @click='nullValue' name='close'></ion-icon>
      <div class='field-preview--swatch' @click.prevent='togglePicker'>

        <div class='field-preview--with-color' v-if='localValue' :style='{backgroundColor: localValue}'></div>
        <div class='field-preview--without-color' v-if='!localValue'></div>
      </div>
      <color-picker :disable-alpha='field.disableAlpha' @input='onColorChange($event)' v-if='showPicker' v-model='colors'></color-picker>
    </div>

    <!--<input @keyup='onKeyUp($event)' v-if='field.type == "color"' :name='name' :placeholder='field.placeholder' type="color" @input='updateOptionImmediately(name, $event)' v-model='localValue' class='field-text' ref='input'/>-->
    <div v-if='field.type =="radio"' class='field-radio'>
      <span class='option' v-for='opt in field.options' :key='opt.label'>
        <input type='radio'
        :name='name'
        v-bind:value='opt.value'
        v-model='localValue'
        @change='updateOptionImmediately(field.name, $event)'>
        <span class='option-label' :style='labelStyle' >{{ opt.label }}</span>
      </span>
    </div>

    <div v-if='field.type =="checkbox"' class='field-radio'>
      <label class='option' v-for='opt in field.options' :key='opt.label'>
        <input type='checkbox'
        :name='name'
        v-bind:value='opt.value'
        v-model='localValue'
        @change='updateOptionImmediately(name, $event)'>
        <span class='option-label' :style='labelStyle' >{{ opt.label }}</span>
      </label>
    </div>

    <div v-if='field.type == "file"' class='field-file' :class='[localValue ? "has-value" :"no-value"]'>
      <label>
        <input type='file' :name='name' @change='updateFileField(name, $event)'>
        <div v-if='localValue' class='file-image-wrapper'>
          <img class='file-image' :src='localValue'/>
        </div>
      </label>
      <p class='file-name' v-if='localValue'><span @click='deleteFileField(name, $event)' class='delete'>
        <ion-icon name='close'></ion-icon></span> {{ localValue | basename | truncate({length: 20, preserveEnds: true}) }}</p>
    </div>

    <select v-model='localValue' v-if='field.type=="select"' :name='name' @change='updateOptionImmediately(name, $event)'>
      <option :value="null" v-if='!field.skipChoose'>{{ selectPlaceholder }}</option>
      <option v-for='option in field.options' :value='mappedOption(option).value'>{{ mappedOption(option).label }}</option>
    </select>

    <transition name="short-fade">
      <div class='field-errors' v-if='field.type !== "repeatable" && errors.length > 0 && initialised'>
        <ul>
          <li v-for='error in errors' v-html='alertIcon + error'></li>
        </ul>
      </div>
    </transition>
    <repeatable ref='input' @change='updateRepeatableField(name, $event)' :singular='field.singular' :plural='field.plural' v-if='field.type == "repeatable"' :list='localValue' :template='field.template'></repeatable>
    <span class='tooltip' :data-tippy-content='tooltip' v-if='tooltip'><i class='fa fa-info-circle'></i></span>
  </div>
</template>
<script>
import Repeatable from './AnswerList.vue'
import Vue from 'vue'
import Validations from './mixins/Validations'
import Utils from './lib/Utilities'
import _ from 'lodash'
import tippy from 'tippy.js'
import { Chrome } from 'vue-color'

export default {
  name: 'field',
  props: {
    field: {default: null, type: Object},
    group: {default: null, type: String},
    name: {default: null, type: String},
    label: {default: '', type: String},
    value: {default: null, type: [String, Boolean, Array, Number, File]},
    validateWith: {default: null, type: [Function, Object]},
    debounce: {default: 300, type: Number},
    uploadPath: {default: '', type: String},
    deletePath: {default: '', type: String},
    tooltip: {default: '', type: String},
    labelStyle: {type: Object, default: () => {{}}},
    inputStyle: {type: Object, default: () => {{}}}
  },
  mixins: [Validations],
  components: {
    'repeatable': Repeatable,
    'color-picker': Chrome
  },
  data () {
    return {
      localValue: null,
      isValid: false,
      errors: [],
      showPicker: false,
      initialised: false,
      imageExists: false,
      showImageURL: false,
      colors: {
        hex: '#194d33'
      },
      alertIcon: '<ion-icon name="alert-circle"></ion-icon>'
    }
  },
  filters: {
    basename (value) {
      return Utils.basename(value)
    },
    truncate (value, len) {
      return Utils.truncate(value, len)
    }
  },
  computed: {
    imageURLFieldType () {
      return this.showImageURL ? 'text' : 'hidden'
    },
    selectPlaceholder () {
      if (typeof this.field.placeholder === 'undefined' || this.field.placeholder === null || this.field.placeholder.trim() === '') {
        return 'Choose...'
      }
      return this.field.placeholder
    },
    isRequiredField () {
      return Utils.dig(this.field, ['validate', 'required'], false)
    },
    randomKey () {
      return Utils.key()
    },
    hasNoStringValue () {
      if (this.localValue === null || this.localValue.toString().trim() === '') {
        return true
      }
      return false
    }
  },
  methods: {
    toggleImageURL () {
      this.showImageURL = !this.showImageURL
    },
    imageLoaded (success) {
      console.log("IMAGE LOAD", success)
      if (success) {
        this.imageExists = true
      } else {
        this.imageExists = false
      }
    },
    openMedia () {
      this.$emit('openmedia', this)
    },
    clearMedia () {
      this.localValue = null
      this.updateOptionImmediately(this.name)
    },
    nullValue () {
      if (this.field.type === 'color') {
        this.localValue = ''
        this.updateOptionImmediately(this.name)
      } else {
        this.localValue = null
      }
    },
    togglePicker () {
      this.showPicker = !this.showPicker
      if(this.showPicker){
        setTimeout(()=>{
          window.addEventListener('click', this.clickListener)
        }, 250)
      }
    },
    clickListener (event) {
      let tgt = event.target
      if(this.showPicker && tgt.closest('.vc-chrome') === null) {
        this.showPicker = false
        window.removeEventListener('click', this.clickListener)
      }
    },
    onColorChange (event) {
      let format = 'hex'
      if (typeof this.field.disableAlpha !== 'undefined' && this.field.disableAlpha === false) {
        format = 'hex8'
      }
      this.localValue = this.colors[format]
      this.updateOptionImmediately(this.name)
    },
    mappedOption (option) {
      if (typeof this.field.optionMap == 'undefined' || !this.field.optionMap) {
        return option
      } else {
        return {
          label: option[this.field.optionMap.label],
          value: option[this.field.optionMap.value]
        }
      }
    },
    focus(){
      this.$refs.input.focus()
    },
    onKeyUp(event){
      if(event.code == "Enter"){
        this.$emit('enter', event)
      }
    },
    updateRepeatableField (name, list) {
      this.localValue = list
      Vue.nextTick(()=>{
        let payload = {value: this.localValue, name: this.name}
        this.$emit('change', payload)
      });
    },
    trixUpdate(ev){
      this.localValue = ev.target.value
      this.initialised = true
      this.validityCheck(ev.target.innerText)
    },
    updateValue (newValue) {
      this.localValue = newValue;
      this.updateOptionImmediately()
    },
    castForFieldType (val) {
      if (this.field.type == 'number') {
        return parseFloat(val)
      } else {
        return val
      }
    },
    validateField () {
      this.initialised = true
      this.validityCheck(this.localValue)
    },
    validityCheck(value){
      Vue.nextTick(function(){
        let validityCheck = this.validateValue(this.validateWith, value)
        let valid = validityCheck.result
        this.errors = validityCheck.errors
        if(valid !== this.isValid){
          this.isValid = valid
         this.$emit('validityChange', {valid: this.isValid, name: this.name, target: this, errors: this.errors, group: this.group})
        }
        if (!valid) {
          return
        }
        let payload = {value: this.castForFieldType(this.localValue), name: this.name, group: this.group, target: this}
        if(this.initialised === true){
          this.$emit('change', payload)
        }
      }.bind(this))
    },
    updateFileField (name, event) {
      let payload = {file: event.target.files[0], name: this.name, group: this.group, target: this}
      this.$emit('change', payload)
    },
    deleteFileField (name, event) {
      let payload = {target: this, path: this.localValue, name: this.name, filename: Utils.basename(this.localValue), group: this.group}
      this.$emit('delete', payload)
    },
    updateOptionDebounced (name, event) {
      _.debounce(
      function(name, event){
        this.initialised = true
        this.validityCheck(this.localValue)
      }.bind(this), this.debounce)()
    },
    updateOptionImmediately (name, event) {
      this.initialised = true
      this.validityCheck(this.localValue)
    },
    setStartingValue () {
      switch (this.field.type) {
        case 'select':
          this.localValue = this.value
          if (this.field.skipChoose === true &&
            this.field.options.length > 0 &&
            this.hasNoStringValue
            ){
            this.localValue = this.field.options[0].value
            let payload = {value: this.localValue, name: this.name, group: this.group, target: this}
            this.$emit('change', payload)
          } else {
            this.localValue = this.value
          }
        break
        default:
          this.localValue = this.value
        break
      }
    }
  },
  created () {
    if( (this.value === '' || this.value === null) && typeof(this.field.default) !== 'undefined'){
      this.localValue = this.field.default
      let payload = {value: this.field.default, name: this.name, group: this.group, target: this}
      this.$emit('change', payload)
    } else {
      this.setStartingValue()
    }
    if (this.field.type === 'color') {
      this.colors = {hex: this.localValue}
    }
    this.debouncedMethod = function(fn){
      return _.debounce(fn, this.debounce)
    }
    this.$watch('field', this.setStartingValue, {deep: true})
  },
  mounted () {
    tippy('[data-tippy-content]')
    let validityValue = this.localValue
    if (this.field.type == 'trix'){
      validityValue = this.$refs.trixfield.innerText
    }
    this.validityCheck(validityValue)
  }
}
</script>
<style lang='scss' scoped>
  @import '../../scss/mixins/effects';
  @import 'trix/dist/trix.css';
  @import 'tippy.js/dist/tippy.css';
  textarea.field-textarea {
    height: 100px;
  }

  /deep/ .field-trix {
    .trix-button-group--file-tools,
    .trix-button-group--block-tools,
    .trix-button--icon-increase-nesting-level,
    .trix-button--icon-decrease-nesting-level { display: none; }
  }

  span.required {
    margin-left: 3px;
    font-weight: bold;
  }

  .option + .option {
    margin-left: 0.5em;
  }


  .field-component.color {
    position: relative;
    .remove-color {
      position: absolute;
      bottom:0%;
      left: 30px;
      background-color: white;
      color: black;
      box-shadow: 0 0 3px rgba(0,0,0,0.5);
      cursor: pointer;
    }
    .field-preview--color {
      position: relative;
    }
    .field--preview-with-color {
      position: relative;
      z-index: 1;
    }
    .field-preview--swatch {
      width: 40px;
      border-radius: 10px;
      z-index: 2;
      > div {
        border-radius: 10px;
        border: 1px solid #888;
        width:40px;
        height:40px;
      }
      .field-preview--without-color {
        //@include grid-background(40px, #cccccc)
        @include missing-background
      }
    }
  }

  .field-component.file, .field-component.media {
    .file-image-wrapper {
      span {
        display: inline-block;
        position: relative;
      }
      width: 100%;
      img {
        width: 100%;
        max-width: 200px;
      }
      .close {
        position: absolute;
        top: 5px;
        right: 5px;
        cursor: pointer;
        ion-icon {
          font-size: 25px;
        }
      }
    }
    a.button {
      background-color: #efefef;
      border: 1px solid #cdcdcd;
      padding: 3px 5px;
      border-radius: 3px;
      color: #333;
      font-size: 11px;
      cursor: pointer;
    }
  }

  /deep/ .vc-chrome {
    position: absolute;
    top:0; left: 0;
    z-index: 3;
    input.vc-input__input {
      min-width: 0 !important;
    }
  }
</style>
